import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";
import {
  addProductStyleAsync,
  addProductFabricUsableAsync,
  deleteProductFabricUsableAsync,
  editProductStyleAsync,
  editProductFabricUsableAsync,
  getProductStyleAsync,
  getProductFabricUsableAsync,
} from "../../../../store/services/productInfoServices";
const FabricUsable = () => {
  const dispatch = useDispatch();
  const {
    getProductFabricUsableStatus,
    getProductFabricUsableError,
    getProductFabricUsableData,
    addProductFabricUsableStatus,
    addProductFabricUsableData,
    addProductFabricUsableError,

    editProductFabricUsableStatus,
    editProductFabricUsableError,
    editProductFabricUsableData,

    deleteProductFabricUsableData,
    deleteProductFabricUsableStatus,
    deleteProductFabricUsableError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductFabricUsableAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductFabricUsableData?.length
    ? getProductFabricUsableData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedFabricUsable, setSelectedFabricUsable] = useState();
  const [addFabricUsableMode, setAddFabricUsableMode] = useState(false);
  const [addFabricUsableData, setAddFabricUsableData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedFabricUsable", selectedFabricUsable);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductFabricUsableStatus === asyncStatus.SUCCEEDED) {
      setAddFabricUsableMode(false);
      setSaveDisabled(true);
      setAddFabricUsableData();
    }
  }, [, addProductFabricUsableStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductFabricUsableAsync(selectedFabricUsable?.fabric_useable_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductFabricUsableStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedFabricUsable();
    }
  }, [, deleteProductFabricUsableStatus]);
  useEffect(() => {
    if (editProductFabricUsableStatus === asyncStatus.SUCCEEDED) {
      setSelectedFabricUsable();
      setEditMode(false);
    }
  }, [, editProductFabricUsableStatus]);
console.log("getProductFabricUsableData",getProductFabricUsableData,editProductFabricUsableData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this fabric usable?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Fabric Usable"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Fabric Usable Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddFabricUsableMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addFabricUsableMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addFabricUsableMode || !selectedFabricUsable}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddFabricUsableMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addFabricUsableMode || !selectedFabricUsable}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductFabricUsableStatus === asyncStatus.LOADING ||
                  editProductFabricUsableStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addFabricUsableData) {
                    dispatch(addProductFabricUsableAsync(addFabricUsableData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedFabricUsable, ...editData };
                    delete a.id;
                    dispatch(editProductFabricUsableAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "fabric_useable_id", headerName: "ID", flex: true },
                  {
                    field: "fabric_useable_name",
                    headerName: "Fabric Usable Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedFabricUsable(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductFabricUsableStatus === asyncStatus.IDLE ||
                  getProductFabricUsableStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addFabricUsableMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Fabric Usable:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddFabricUsableData({
                            ...addFabricUsableData,
                            fabric_useable_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddFabricUsableData({
                            ...addFabricUsableData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedFabricUsable ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedFabricUsable?.fabric_useable_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "Fabric Usable:",
                    comp: (
                      <InputComp
                        key={selectedFabricUsable?.fabric_useable_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            fabric_useable_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedFabricUsable?.fabric_useable_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedFabricUsable?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedFabricUsable?.is_active ? true : false
                        }
                        checked={selectedFabricUsable?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any fabric usable</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductFabricUsableError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductFabricUsableError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductFabricUsableError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductFabricUsableError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedFabricUsable(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedFabricUsable(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default FabricUsable;
